import { defineComponent as u, useAttrs as d, computed as f, createBlock as c, openBlock as o, resolveDynamicComponent as y, mergeProps as g, unref as r, withCtx as I, createElementBlock as l, createCommentVNode as n, createElementVNode as h, createVNode as t, renderSlot as z } from "vue";
import { _ as a } from "./UiIcon.vue_vue_type_script_setup_true_lang-BEUNoCyM.js";
/* empty css                                                */
import "./vue3-lottie.es-BQlzj7s3.js";
import "./style-R_nxVIjQ.js";
/* empty css                                                         */
/* empty css                                                    */
import "./useDatePicker-DAFR8Jnp.js";
import "../config/index.js";
/* empty css                                                           */
/* empty css                                                       */
/* empty css                                                   */
/* empty css                                                  */
/* empty css                                                    */
/* empty css                                                    */
/* empty css                                                    */
/* empty css                                                  */
/* empty css                                                      */
import "vue-router";
/* empty css                                                */
import { _ as C } from "./UiLoading.vue_vue_type_script_setup_true_lang-CrLaqUzi.js";
/* empty css                                                 */
/* empty css                                                      */
/* empty css                                                        */
/* empty css                                                    */
/* empty css                                                */
/* empty css                                                    */
/* empty css                                                               */
/* empty css                                                    */
const b = {
  key: 0,
  class: "ui-button__icon-slot"
}, T = { class: "ui-button__content" }, N = {
  key: 1,
  class: "ui-button__icon-slot"
}, ee = /* @__PURE__ */ u({
  __name: "UiButton",
  props: {
    link: { type: Boolean },
    target: {},
    size: { default: "lg" },
    nativeType: { default: "button" },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    type: { default: "primary" },
    mode: { default: "accent" },
    leftIconType: { default: "400" },
    leftIconName: { default: "" },
    leftIconColor: { default: "" },
    leftIconSize: { default: "sm" },
    rightIconType: { default: "400" },
    rightIconName: { default: "" },
    rightIconColor: { default: "" },
    rightIconSize: { default: "sm" },
    to: {},
    outlineTypeColor: {}
  },
  setup(p) {
    const i = d(), s = p, m = f(() => i.href ? "a" : s.to ? "router-link" : "button");
    return (e, k) => (o(), c(y(m.value), g(r(i), {
      class: ["ui-button", [
        `size-${e.size}`,
        `type-${e.type}`,
        `mode-${e.mode}`,
        {
          "is-loading": e.loading
        }
      ]],
      target: e.target,
      to: e.to,
      disabled: e.disabled || e.loading,
      type: e.nativeType,
      style: e.outlineTypeColor && e.type === "outline" && { "--color-state-accent": e.outlineTypeColor }
    }), {
      default: I(() => [
        e.leftIconName ? (o(), l("span", b, [
          t(a, {
            type: e.leftIconType,
            name: e.leftIconName,
            color: e.leftIconColor,
            size: e.leftIconSize
          }, null, 8, ["type", "name", "color", "size"])
        ])) : n("", !0),
        h("span", T, [
          z(e.$slots, "default")
        ]),
        e.rightIconName ? (o(), l("span", N, [
          t(a, {
            type: e.rightIconType,
            name: e.rightIconName,
            color: e.rightIconColor,
            size: e.rightIconSize
          }, null, 8, ["type", "name", "color", "size"])
        ])) : n("", !0),
        t(r(C), {
          "is-show": e.loading,
          "icon-size": "fill"
        }, null, 8, ["is-show"])
      ]),
      _: 3
    }, 16, ["target", "to", "class", "disabled", "type", "style"]));
  }
});
export {
  ee as _
};
